define('lib/collection/BaseCollection',['require','backbone'],function (require) {

	var Backbone = require('backbone');
	
	/**
	 * Base collection with url rewriter
	 * 
	 * @class BaseCOllection
	 */
	return Backbone.Collection.extend({
		
		baseUrl: '/v2',
		_loaded: false,
        _synchronized: false,
		_loadingPromise: null,
		
		/**
		 * Inits class
		 */
		initialize: function () {
			if (this.url) {
				this.url = this.baseUrl + this.url;
			}

			this.listenTo(this, 'sync', this._resetSynchronizedFlag);

			Backbone.Collection.prototype.initialize.call(this);
		},

        /**
		 * Reset flag _synchronized
		 *
         * @private
         */
        _resetSynchronizedFlag: function () {
			this._synchronized = true;
		},
        
        unsetSynchronizedFlag: function () {
			this._synchronized = false;
		},

        /**
		 * Return true if collection was synchronized
		 *
		 * @return boolean
         */
		hasSynchronized: function () {
			return this._synchronized;
		},
        
        isLoaded: function () {
            return this._loaded;
        },

		resetLoaded: function () {
			this._loaded = false;
			this._loadingPromise = null;
		},

		/**
		 * Returns json object of model data by PK
		 * if model does not exist returns null
		 * 
		 * @return Object|null
		 */
		getModelObj: function (id) {
			var data = this.get(id);
	    	var obj = null;
	    	if (data) {
	    		obj = data.toJSON();
	    	}
	   		
	    	return obj;
		},

		/**
		 * Loads data from server only once
		 */
		load: function (options) {
			if (!this._loaded) {
				this.fetch(options);
				this._loaded = true;
			}
		},
        
        reload: function (options) {
            this._loaded = false;
            this.load(options);
        },
        
        refetch: function (options) {
            this._loaded = false;
            return this.load(options);
        },

		loadWithPromise: function (options) {
			if (this._loadingPromise) {
				return this._loadingPromise;
			} else {
				var _this = this;
				this._loadingPromise = new Promise(function (resolve, reject) {
					_this.fetch(_.extend(options, {
						success: resolve,
						error: function(model, xhr) {
							reject(xhr.responseJSON);
						}
					}));
					_this._loaded = true;
				});
				return this._loadingPromise;
			}
		}
		
	});
	
});
